import { render, staticRenderFns } from "./tipovi-vozila.editor.vue?vue&type=template&id=8cc869c4&scoped=true&"
import script from "./tipovi-vozila.editor.vue?vue&type=script&lang=ts&"
export * from "./tipovi-vozila.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc869c4",
  null
  
)

export default component.exports